import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ZEROSIXCREATEACCOUNTMODAL_LEGACY_FIELD_ORDER = [
  "legal_checkbox_label"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  zerosixCreateAccountModalDescriptor: _generatedZerosixCreateAccountModalDescriptor,
  zerosixCreateAccountModalModalDefinition,
  zerosixCreateAccountModalDashboardLayout,
  zerosixCreateAccountModalConfig,
  zerosixCreateAccountModalResolveConfig,
  zerosixCreateAccountModalProperties,
} = doodModalConfig(
  {
    name: "Zerosix - Create account modal",
    handle: "zerosix-create-account-modal",
    internal_name: "ZerosixCreateAccountModal",
    componentType: 'ZerosixCreateAccountModalComponent',
    category: 'modal',
    description: "Zerosix - Create account modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "zerosix-create-account-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    }),
    legal_checkbox_label: propertyValue({
      type: 'wysiwyg',
      value: '',
      options: {
        "label": "Legal checkbox label",
        "help": "Legal text displayed next to the consent checkbox"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color", "legal_checkbox_label"],
          },
        ],
      },
    ],
  })
);

export function zerosixCreateAccountModalDescriptor(): IBlockDescriptor;
export function zerosixCreateAccountModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function zerosixCreateAccountModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedZerosixCreateAccountModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedZerosixCreateAccountModalDescriptor, zerosixCreateAccountModalProperties, fieldOrder);
}

export {
  zerosixCreateAccountModalModalDefinition,
  zerosixCreateAccountModalDashboardLayout,
  zerosixCreateAccountModalProperties,
  zerosixCreateAccountModalConfig,
  zerosixCreateAccountModalResolveConfig,
};

export type ZerosixCreateAccountModalConfig = typeof zerosixCreateAccountModalConfig;
